import { UAParser } from 'ua-parser-js'

export const isMobileDevice = (userAgent: string | undefined) => {
  if (!userAgent) return false
  const parser = new UAParser(userAgent)
  return parser.getDevice().type === 'mobile'
}

/** Returns the model, type and vendor of the non-desktop device */
export const getDeviceInfo = (userAgent: string | undefined) => {
  if (!userAgent) return false
  const parser = new UAParser(userAgent)
  const device = parser.getDevice()

  if (device.type === 'mobile' || device.type === 'tablet') return device

  return { type: 'desktop' }
}
